import { render, staticRenderFns } from "./AnswerSubmitForm.vue?vue&type=template&id=57fb69f2&"
import script from "./AnswerSubmitForm.vue?vue&type=script&lang=js&"
export * from "./AnswerSubmitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports